var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEditgroup = function SvgEditgroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#editgroup_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 29,
    r: 28,
    fill: "#F9FAFA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 29,
    r: 27.5,
    stroke: "#C5CED6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#405261",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M38.793 24.523a2.023 2.023 0 1 1-2.862 2.861 2.023 2.023 0 0 1 2.861-2.86M32.203 20.912a3.115 3.115 0 1 1-4.405 4.406 3.115 3.115 0 0 1 4.405-4.406M24.069 24.523a2.023 2.023 0 1 1-2.862 2.861 2.023 2.023 0 0 1 2.861-2.86M41 34v-1.096a2.5 2.5 0 0 0-2.5-2.5h-.801M19 34v-1.096a2.5 2.5 0 0 1 2.5-2.5h.801M35.339 34v-1.601a3.5 3.5 0 0 0-3.5-3.5H28.16a3.5 3.5 0 0 0-3.5 3.5v1.6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "editgroup_svg__a",
    width: 60,
    height: 60,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0235294 0 0 0 0 0.0823529 0 0 0 0 0.133333 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1844_8358"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1844_8358",
    result: "shape"
  })))));
};
export { SvgEditgroup as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiNmYyODM5MzkwMzdmYWQxMjc4NTljMDdmZDliNDk0YTMuc3ZnIjs=";